import { render, staticRenderFns } from "./navigation-bar.component.vue?vue&type=template&id=2528258d&scoped=true&"
import script from "./navigation-bar.component.vue?vue&type=script&lang=js&"
export * from "./navigation-bar.component.vue?vue&type=script&lang=js&"
import style0 from "./navigation-bar.component.vue?vue&type=style&index=0&id=2528258d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2528258d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBarNavIcon,VBtn,VCol,VContainer,VIcon,VImg,VRow})
